<template>
    <div>
      <!--编辑巡检信息-->
      <el-dialog :visible.sync="updateInspectRecordDialogVisible" title="编辑巡检信息" @close="feedBack" v-if="updateInspectRecordDialogVisible">
        <el-form label-width="100px" :model="AltInspectRecord.params" :ref="AltInspectRecord.params" :rules="rulesOfAltInspectRecord">
          <el-form-item label="巡检时间" prop="inspectTime">
            <el-date-picker type="datetime" v-model="AltInspectRecord.params.inspectTime" value-format="yyyy-HH-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item label="巡检内容" prop="inspectContent">
            <el-input type="textarea" :row="2" v-model="AltInspectRecord.params.inspectContent"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="feedBack">取 消</el-button>
          <el-button type="primary" @click="checkAltInspectRecord">确定修改</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
  export default {
    name: 'UpdateInspectRecord',
    props: ['updateInspectRecordDialogVisible', 'AltInspectRecord'],
    data(){
      return {
        rulesOfAltInspectRecord:{
          inspectTime: [{required: true, message:'巡检时间不能为空', trigger: 'change'}],
          inspectContent:[{required: true, message:'巡检内容不能为空', trigger: 'change'}],
        },
      }
    },
    methods: {
      feedBack(){
        this.resetValidate(this.AltInspectRecord.params);
        this.updateInspectRecordDialogVisible = false;
        this.$emit('feedBack',this.updateInspectRecordDialogVisible);
      },
      checkAltInspectRecord(){
        this.$refs[this.AltInspectRecord.params].validate((valid)=>{
          if(valid){
            this.altInspectRecord();
          }
          else{
            return false;
          }
        })
      },
      altInspectRecord(){
        this.AltInspectRecord.token = this.$store.state.token;
        console.log('修改巡检记录请求');
        console.log(this.AltInspectRecord);
        this.$axios.post(this.$mainUrl, this.AltInspectRecord).then(res =>{
          console.log('修改巡检记录请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.$message({
              type: 'success',
              message: '修改巡检记录成功'
            })
            this.feedBack();
          }
          else{
            this.$message({
              type: 'error',
              message: '修改巡检记录失败，' + res.data.error,message
            })
          }
        })
      }
    }

  }
</script>

<style scoped>

</style>
